/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanFramePeopleIcon16Light } from './ScanFramePeopleIcon16Light';
import { ScanFramePeopleIcon16Regular } from './ScanFramePeopleIcon16Regular';
import { ScanFramePeopleIcon16Solid } from './ScanFramePeopleIcon16Solid';
import { ScanFramePeopleIcon20Light } from './ScanFramePeopleIcon20Light';
import { ScanFramePeopleIcon20Regular } from './ScanFramePeopleIcon20Regular';
import { ScanFramePeopleIcon20Solid } from './ScanFramePeopleIcon20Solid';
import { ScanFramePeopleIcon24Regular } from './ScanFramePeopleIcon24Regular';
import { ScanFramePeopleIcon24Solid } from './ScanFramePeopleIcon24Solid';
import { ScanFramePeopleIcon32Regular } from './ScanFramePeopleIcon32Regular';
import { ScanFramePeopleIcon64Regular } from './ScanFramePeopleIcon64Regular';
var sizes = {
    16: {
        light: ScanFramePeopleIcon16Light,
        regular: ScanFramePeopleIcon16Regular,
        solid: ScanFramePeopleIcon16Solid,
    },
    20: {
        light: ScanFramePeopleIcon20Light,
        regular: ScanFramePeopleIcon20Regular,
        solid: ScanFramePeopleIcon20Solid,
    },
    24: {
        regular: ScanFramePeopleIcon24Regular,
        solid: ScanFramePeopleIcon24Solid,
    },
    32: {
        regular: ScanFramePeopleIcon32Regular,
    },
    64: {
        regular: ScanFramePeopleIcon64Regular,
    },
};
export var ScanFramePeopleIcon = forwardRef('ScanFramePeopleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
